"use strict";

$.fn.setDatatable = function () {
    this.each(function () {
        var tableContainer = $(this);
        var table = $("table", tableContainer);
        var dataLoadController = tableContainer.data("loadController");
        var dataLoadAction = tableContainer.data("loadAction");
        var definition = tableContainer.data("columns");
        var order = tableContainer.data("order");
        var columnsDatas = [];
        var searchCols = [];
        var searchValues = {};
        var orderCellsTop = tableContainer.data("orderCellsTop");
        // Construction de la liste de colonnes et des filtres par défaut
        definition.map(function (def) {
            columnsDatas.push({
                data: {
                    _: def.name,
                    displayable: def.displayable
                },
                name: def.name,
                visible: def.visible,
                orderable: def.orderable,
                searchable: def.searchable,
                search: def.search,
                render: function render(data) {
                    if (!data) {
                        return "";
                    }
                    if (def.type === "date") {
                        return new Date(data).toLocaleDateString();
                    }
                    if (data instanceof Array) {
                        if (data.length == 0) {
                            return "";
                        }
                        var list = $("<ul class='datatable-cell-list'>");
                        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                            var item = data_1[_i];
                            list.append($("<li>").append(item.url ? $("<a>", { href: item.url }).text(item.label) : item.label));
                        }
                        return list[0].outerHTML;
                    }
                    return data;
                }
            });
            var searchValue = null;
            if (def.search && def.search.value != null) {
                searchValue = def.search.value;
                searchValues[def.name] = searchValue;
            }
            searchCols.push({
                search: searchValue
            });
        });
        tableContainer.trigger("init-values-before-datatable", searchValues);
        var pageLength = parseInt($("input#pageLength", tableContainer).val());
        var startPage = parseInt($("input#pageStart", tableContainer).val());
        var options = {
            pageLength: pageLength,
            displayStart: pageLength * (startPage - 1),
            dom: tableContainer.data("dom") || 'rt<"bottom w-100 text-center"pl>i<"clear">',
            bSortCellsTop: orderCellsTop,
            language: {
                processing: "<i class=\"fa fa-spinner fa-spin fa-5x\"></i>"
            },
            processing: true,
            serverSide: true,
            autoWidth: false,
            ajax: {
                url: "/" + dataLoadController + "/" + dataLoadAction,
                type: "POST",
                dataType: "json",
                data: function data(d) {
                    d["customVars"] = tableContainer.data("customVars");
                    var tocolumns = d["columns"];
                    definition.map(function (c) {
                        var column = tocolumns.find(function (_) {
                            return _.name === c.name;
                        });
                        $.each(c, function (name, value) {
                            if (!column[name]) {
                                column[name] = value;
                            }
                        });
                    });
                    d["columns"] = tocolumns;
                    return {
                        data: d
                    };
                },
                error: function error(xhr) {
                    if (xhr && xhr.status == 401) {
                        document.location.reload();
                        return;
                    }
                    throw new Error("Ajax error");
                }
            },
            order: order ? order.map(function (_) {
                return [_.column, _.dir];
            }) : [],
            columns: columnsDatas,
            searchCols: searchCols,
            createdRow: function createdRow(row, data, dataIndex) {
                if (data["RouteUrl"]) {
                    $(row).attr("data-route-url", data["RouteUrl"]);
                }
                if (data["DataAttribut"]) {
                    var colsAttr = JSON.parse(data["DataAttribut"]);
                    var ths = table.find("th");
                    var tds = $(row).find("td");
                    for (var property in colsAttr) {
                        if (colsAttr.hasOwnProperty(property)) {
                            var i = ths.index($("th[data-column=" + property + "]"));
                            var $td = $(tds[i]);
                            var attrs = JSON.parse(colsAttr[property]);
                            for (var prop in attrs) {
                                if (attrs.hasOwnProperty(prop)) {
                                    $td.attr("data-" + prop, attrs[prop] instanceof Object ? JSON.stringify(attrs[prop]) : attrs[prop]);
                                }
                            }
                        }
                    }
                    tds.filter("[data-format-view-template]").each(function () {
                        var $cell = $(this);
                        var templateName = $cell.data("format-view-template");
                        var templates = $.datatablesTemplates.filter(function (_) {
                            return _.name === templateName;
                        });
                        if (templates.length == 0) {
                            return;
                        }
                        var template = templates[0];
                        $cell.html(template.callback(data));
                    });
                }
                tableContainer.trigger("createdRow", [row, data]);
            },
            inlineEdit: {
                enabled: true
            }
        };
        // Connexion du datatable
        var datatable = table.DataTable(options);
        tableContainer.data("datatable", datatable);
        datatable.on("page.dt", function () {
            $("ul.pagination input.page", tableContainer).val(datatable.page() + 1);
            tableContainer.trigger("filter-change", { source: "page.dt" });
        });
        datatable.on("draw", function () {
            $("div.dataTables_length > label", tableContainer).css({
                width: "auto"
            });
            tableContainer.trigger("draw");
        });
        table.on("click", "tr", function () {
            var $row = $(this);
            if ($row.attr("data-route-url")) {
                document.location.assign($row.attr("data-route-url"));
            }
        });
        table.on("click", "th.orderable", function () {
            tableContainer.trigger("filter-change", { source: "sort" });
        });
        // Connexion au bouton de filtre pour switcher entre tri et filtre
        $("thead button.filter", table).on("click", function () {
            $(this).parents("tr").toggleClass("labels").toggleClass("inputs");
        });
        $("thead .unfilter", table).on("click", function () {
            $(this).parents("thead").find(".datatable-filter.datatable-filter-select2").each(function () {
                var $filter = $(this).html("");
                var column = datatable.columns($filter.data("column") + ":name");
                column.search("");
                $(column.header()[0]).removeClass("filtered");
                var columDisplayName = $filter.data("column-display");
                if (columDisplayName && columDisplayName !== $filter.data("column")) {
                    $(datatable.columns(columDisplayName + ":name").header()[0]).removeClass("filtered");
                }
            });
            tableContainer.trigger("filter-change", { source: "column-filter.unfilter" });
            datatable.draw();
        });
        // Bouton de suppression de colonne
        $("thead span.remove", table).on("click", function () {
            var $th = $(this).parents("th");
            var column = datatable.columns($th.data("column") + ":name");
            column.visible(false);
            tableContainer.trigger("filter-change", { source: "column.remove" });
        });
        // Pour empêcher le tri lors du clic
        $("div.search, thead span.remove", table).on("click", function (e) {
            e.stopImmediatePropagation();
        });
        // Connexion à la pagination
        $("ul.pagination a").on("click", function () {
            var $this = $(this),
                $li = $this.parent(),
                $ul = $li.parent(),
                $first = $("li.page-item:not(.previous):first", $ul),
                $last = $("li.page-item:not(.next):last", $ul);
            if ($li === $first) {
                tableContainer.trigger("filter-change", { source: "page.first" });
            } else if ($li === $last) {
                tableContainer.trigger("filter-change", { source: "page.last" });
            } else if ($li.hasClass("previous")) {
                tableContainer.trigger("filter-change", { source: "page.previous" });
            } else if ($li.hasClass("next")) {
                tableContainer.trigger("filter-change", { source: "page.next" });
            } else {
                tableContainer.trigger("filter-change", { source: "page.input" });
            }
            $(this).trigger("blur");
        });
        $("div.dataTables_length select", tableContainer).on("change", function () {
            tableContainer.trigger("filter-change", { source: "length.change" });
        });
        // Comportement des champs de filtres des colonnes
        $("thead .datatable-filter.datatable-filter-select2", table).on("change", function (e, extraParam) {
            var $filter = $(this);
            var column = datatable.columns($filter.data("column") + ":name");
            if (!extraParam || !extraParam.noRefresh) {
                // Collage des valeurs sélectionnées avec une virgule
                var value = $filter.select2("data").map(function (_) {
                    return _.id;
                }).join(",");
                if (column.search() !== value) {
                    column.search(value).draw();
                    tableContainer.trigger("filter-change", { source: "column-filter.change" });
                }
            }
            $(column.header()[0]).toggleClass("filtered", $filter.select2("data").length > 0);
            var columDisplayName = $filter.data("column-display");
            if (columDisplayName && columDisplayName !== $filter.data("column")) {
                $(datatable.columns(columDisplayName + ":name").header()[0]).toggleClass("filtered", $filter.select2("data").length > 0);
            }
        }).each(function () {
            var $el = $(this);
            var colName = $el.data("column");
            var fnData = $el.data("select2-data");
            var data = fnData ? $[fnData] ? $[fnData]($el) : fnData : "";
            $el.select2(data);
            if (searchValues[colName]) {
                var value = searchValues[colName];
                var options_1 = value.split(",");
                $el.html(options_1.map(function (v) {
                    return "<option selected>" + v + "</option>";
                }).join()).trigger("change", { noRefresh: true });
            }
        });
        // Comportement des filtres personnalisés
        // Filtre de type multi valeurs
        $(".datatable-filter-custom.datatable-filter-select2", tableContainer).each(function () {
            var $this = $(this),
                colName = $(this).data("column");
            var fnData = $this.data("select2-data");
            var data = fnData ? $[fnData] ? $[fnData]($this) : fnData : "";
            $this.select2(data);
            if (searchValues[colName]) {
                var values_1 = searchValues[colName].split(",");
                $.ajax({
                    url: data ? data.ajax.url || $this.data("ajax--url") : $this.data("ajax--url"),
                    method: "get"
                }).done(function (response) {
                    $this.html("");
                    $.each(response.results, function (i, item) {
                        $this.append($("<option>", {
                            selected: values_1.indexOf(item.id) != -1,
                            value: item.id,
                            text: item.text,
                            css: item.css != null ? item.css : " "
                        }));
                    });
                    $this.trigger("change", { noRefresh: true });
                });
            }
        }).on("change", function (e, extraParam) {
            if (!extraParam || !extraParam.noRefresh) {
                var $filter = $(this);
                var column = datatable.columns($filter.data("column") + ":name");
                // Collage des valeurs sélectionnées avec une virgule
                var value = $filter.select2("data").map(function (_) {
                    return _.id;
                }).join(",");
                if (column.search() !== value) {
                    column.search(value);
                    tableContainer.trigger("filter-change", {
                        source: "custom-filter-select2.change",
                        control: $filter
                    });
                }
            }
        });
        // Filtres de type boolean
        $(".datatable-filter-custom.datatable-filter-boolean", tableContainer).each(function () {
            var colName = $(this).data("column");
            if (searchValues[colName]) {
                $(this).prop("checked", searchValues[colName] === "true");
            }
        }).on("change", function () {
            var $filter = $(this);
            var column = datatable.columns($filter.data("column") + ":name");
            var value = $filter.prop("checked") ? "1" : "0";
            if (column.search() !== value) {
                column.search(value);
                tableContainer.trigger("filter-change", { source: "custom-filter-boolean.change" });
            }
        });
        // Filtres de type date
        $(".datatable-filter-custom.datatable-filter-date", tableContainer).datetimepicker().each(function () {
            var colName = $(this).data("column");
            if (searchValues[colName]) {
                $(this).val(searchValues[colName]);
            }
        }).on("dp.change", function () {
            var $filter = $(this);
            var column = datatable.columns($filter.data("column") + ":name");
            var value = $filter.val();
            if (column.search() !== value) {
                column.search(value);
                tableContainer.trigger("filter-change", { source: "custom-filter-date.change" });
            }
        });
        // Filtres de type template
        $(".datatable-filter-custom.datatable-filter-template", tableContainer).each(function () {
            var colName = $(this).data("column");
            if (searchValues[colName]) {
                $(this).val(searchValues[colName]);
            }
        }).on("change", function () {
            var $filter = $(this);
            var column = datatable.columns($filter.data("column") + ":name");
            var value = $filter.val();
            if (column.search() !== value) {
                column.search(value);
                tableContainer.trigger("filter-change", { source: "custom-filter-template.change" });
            }
        });
        //Autres filtres
        tableContainer.trigger("add-more-filter", { searchValues: searchValues });
        // Clic sur OK de la modale des filtres
        $("#modal-datatable-custom-filters .btn-success", tableContainer).click(function () {
            datatable.draw();
        });
    });
    return this;
};
/**
 * Télécharge un CSV à partir d'un élement racine de Datatable, grâce à une URL
 *
 * @param url
 */
$.fn.downloadCsv = function (url) {
    var $table = $(this);
    var datatable = $table.data("datatable");
    if (!datatable) {
        return;
    }
    var params = datatable.ajax.params();
    var $body = $("body");
    var $downloadForm = $("<form method='post' target='csv-download' action='" + url + "'></form>").hide().appendTo($body);
    $('<input name="parameters" />').val(JSON.stringify(params.data)).appendTo($downloadForm);
    var $iframe = $("#csv-download");
    if ($iframe.length == 0) {
        $("<iframe name='csv-download' id='csv-download' style='position:absolute;width:0;height:0;border:none;'></iframe>").appendTo($body);
    }
    $downloadForm.get(0).submit();
    $downloadForm.remove();
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Datatable/initDatatable.ts
// module id = 521
// module chunks = 0